import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    title: {
      margin: "auto",
      textAlign: "center",
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 600,
      letterSpacing: 1.09,
      lineHeight: theme.typography.pxToRem(34),
      [theme.breakpoints.up("mobile")]: {
        maxWidth: "none",
        fontSize: theme.typography.pxToRem(23),
        lineHeight: theme.typography.pxToRem(28),
        letterSpacing: 1.25,
        marginBottom: 15,
      },
      [theme.breakpoints.up("tablet")]: {
        fontSize: theme.typography.pxToRem(28),
        lineHeight: theme.typography.pxToRem(34),
        letterSpacing: 1.5,
      },
    },
  }),
  { name: "Title" },
);
